import React from "react";
import { Pagination, PaginationLink, PaginationItem } from "reactstrap";
import Icon from "../icon/Icon";

const PaginationComponent = ({ itemPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];
  
  // Protection contre les valeurs undefined ou invalides
  const safeItemPerPage = itemPerPage || 10;
  const safeTotalItems = totalItems || 0;
  const safeCurrentPage = currentPage || 1;

  for (let i = 1; i <= Math.ceil(safeTotalItems / safeItemPerPage); i++) {
    pageNumbers.push(i);
  }

  const nextPage = () => {
    if (paginate && typeof paginate === 'function') {
      paginate(safeCurrentPage + 1);
    }
  };

  const prevPage = () => {
    if (paginate && typeof paginate === 'function') {
      paginate(safeCurrentPage - 1);
    }
  };

  // Ne rien afficher si pas de pages
  if (!Array.isArray(pageNumbers) || pageNumbers.length === 0) {
    return null;
  }

  return (
    <Pagination aria-label="Page navigation example">
      <PaginationItem disabled={safeCurrentPage - 1 === 0 ? true : false}>
        <PaginationLink
          className="page-link-prev"
          onClick={(ev) => {
            ev.preventDefault();
            prevPage();
          }}
          href="#prev"
        >
          <Icon name="chevrons-left" />
          <span>Prev</span>
        </PaginationLink>
      </PaginationItem>
      {Array.isArray(pageNumbers) && pageNumbers.map((item) => {
        return (
          <PaginationItem className={safeCurrentPage === item ? "active" : ""} key={item}>
            <PaginationLink
              tag="a"
              href="#pageitem"
              onClick={(ev) => {
                ev.preventDefault();
                if (paginate && typeof paginate === 'function') {
                  paginate(item);
                }
              }}
            >
              {item}
            </PaginationLink>
          </PaginationItem>
        );
      })}

      <PaginationItem disabled={pageNumbers.length > 0 && pageNumbers[pageNumbers.length - 1] === safeCurrentPage}>
        <PaginationLink
          className="page-link-next"
          onClick={(ev) => {
            ev.preventDefault();
            nextPage();
          }}
          href="#next"
        >
          <span>Next</span>
          <Icon name="chevrons-right" />
        </PaginationLink>
      </PaginationItem>
    </Pagination>
  );
};
export default PaginationComponent;
